import React from 'react/addons';
import cx from 'classnames';

const DesktopBreadbar = React.createClass({
  propTypes: {
    currentPage: React.PropTypes.string.isRequired,
    links: React.PropTypes.object.isRequired,
    /**
    * EXAMPLE SHAPE FOR 'LINKS'
    * links = {
    *   'book-capture-details': {
    *     url: '/book/B42FYW/pre-stay/details',
    *     title: 'Your details',
    *   },
    * };
    **/
  },

  renderLink(slug) {
    const {currentPage, links} = this.props;
    const linkClasses = cx({
      "ofs-Prestay__BreadbarLink": true,
      "ofs-Prestay__BreadbarLink--is-selected": currentPage === slug,
    });

    return (
      <li key={slug} className="ofs-List__Item ofs-List__Item--horizontal-inline">
        <a className={linkClasses} href={links[slug].url}>{links[slug].title}</a>
      </li>
    );
  }, 

  render() {
    const {links} = this.props;
    const breadbarLinks = Object.keys(links).map((slug) => this.renderLink(slug));
    return (
      <ul className="ofs-List">
        {breadbarLinks}
      </ul> 
    );
  }
});

export default DesktopBreadbar;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/views/_DesktopBreadbar.jsx
 **/